module.exports = __webpack_public_path__ + "img/full-bg.77604cb6.jpg";